import React from "react";
import withAuth from '../../components/hoc/withAuth';
import Placeholder from '../../components/ui/Placeholder';

const RegulatoryReporting = () => {
    return (
        <Placeholder title='Regulatory Reporting' />
    );
};

export default withAuth(RegulatoryReporting);
